import { schema } from 'normalizr'

// Schemas
import { subscriptionSchema } from 'modules/subscription/models'
import { discountListSchema } from 'modules/price/models'

// Types
import { Subscription, SavedPaymentMethod } from 'types'

export type Email = {
  email: string
  verified: boolean
  primary: false
}

export type Profile = {
  readonly id: number
  readonly accepted_eula: number
  readonly address: string
  readonly alias: string
  readonly avatar: string
  readonly company_name: string
  readonly country: string
  readonly currency: string
  readonly date_joined: string
  readonly deleted_date: string | null | undefined
  readonly description: string
  readonly download_token: string
  readonly email: string
  readonly emails: Array<Email>
  readonly favorites_collection_id: number
  readonly full_name: string
  readonly groups: Array<string>
  readonly invite_key: string
  readonly invites: Array<number>
  readonly invoice_payment_allowed: boolean
  readonly is_deleted: boolean
  readonly is_staff: boolean
  readonly is_subscribed: boolean
  readonly is_unsubscribed: boolean
  readonly landing_url: string | null | undefined
  readonly last_visited: string
  readonly license_vat: number
  readonly onboarded: boolean
  readonly phone_number: string
  readonly purchased_tracks: Array<{
    track: number
    created_at: string
  }>
  readonly saved_payment_methods_remote: Array<SavedPaymentMethod>
  readonly saved_payment_methods: Array<SavedPaymentMethod>
  readonly show_prices_with_vat: boolean
  readonly signup_url: string | null | undefined
  readonly subscription: (Subscription | null | undefined) | (number | null | undefined)
  readonly track_price: number
  readonly track_vat: number
  readonly user: number
  readonly website: string
  readonly soundcloud: string
  readonly beatstars: string
  readonly instagram: string
  readonly youtube: string
  readonly theme: string
}

export const ProfileDefaultValues: Profile = {
  id: 0,
  accepted_eula: 1,
  address: '',
  alias: '',
  avatar: '/static/images/default-avatar.png.100x100_q85_crop.jpg',
  company_name: '',
  country: 'US',
  currency: '',
  date_joined: '',
  deleted_date: null,
  description: '',
  download_token: '',
  email: '',
  emails: [],
  favorites_collection_id: 0,
  full_name: 'Not logged in',
  groups: [],
  invite_key: '',
  invites: [],
  invoice_payment_allowed: false,
  is_deleted: false,
  is_staff: false,
  is_subscribed: false,
  is_unsubscribed: false,
  landing_url: null,
  last_visited: '',
  license_vat: 0,
  onboarded: false,
  phone_number: '',
  purchased_tracks: [],
  saved_payment_methods_remote: [],
  saved_payment_methods: [],
  show_prices_with_vat: false,
  signup_url: null,
  subscription: null,
  track_price: 0,
  track_vat: 0,
  user: 0,
  website: '',
  soundcloud: '',
  beatstars: '',
  instagram: '',
  youtube: '',
  theme: 'default',
}

export type Invite = {
  id: number
  created: string
  email: string
  status: 'INVITE_SENT' | 'INVITE_ACCEPTED' | 'BONUS_ACTIVATED'
  sent: boolean
}

export const inviteSchema = new schema.Entity('invites')
export const inviteListSchema = [inviteSchema]

export const profileSchema = new schema.Entity('profiles', {
  invites: inviteListSchema,
  discounts: discountListSchema,
  subscription: subscriptionSchema,
})

export const profileListSchema = [profileSchema]
